export var FilterOrigin;
(function (FilterOrigin) {
    FilterOrigin["popup"] = "popup";
    FilterOrigin["web"] = "web";
    FilterOrigin["devtools"] = "devtools";
    FilterOrigin["wizard"] = "wizard";
    FilterOrigin["youtube"] = "youtube";
    FilterOrigin["customize"] = "customize";
    FilterOrigin["context"] = "context";
})(FilterOrigin || (FilterOrigin = {}));
